<app-header></app-header>
<div style="min-height: calc(100vh - 155px)">
  <router-outlet></router-outlet>
</div>

<footer class="footer-area mt-2">
  <!--== Start Footer Bottom ==-->
  <div class="footer-bottom">
    <div class="container pt--0 pb--0">
      <div class="row">
        <div class="col-md-7 col-lg-6">
          <p class="copyright">
            © 2025 SHIVAM ITCS - Food order online. Made with
            <i class="fa fa-heart"></i> by
            <a target="_blank" href="https://shivamitcs.in/">shivam.</a>
          </p>
        </div>
        <div class="col-md-5 col-lg-6">
          <div class="payment"></div>
        </div>
      </div>
    </div>
  </div>
  <!--== End Footer Bottom ==-->
</footer>
